import React from 'react';
import { useTranslation } from 'react-i18next';
import './mission-card.scss';

interface MissionCardProps {
  title: string;
  completed: number;
  total: number;
  percentage: number;
  color?: string;
  textColor?: string;
  status?: 0 | 1 | 2;
  type?: 'lesson' | 'exercise';
  onPress?: () => void;
  loading?: boolean;
}

const MissionCard: React.FC<MissionCardProps> = ({ title, completed, total, percentage, color, textColor, status = 0, type = 'lesson', onPress, loading }) => {
  const { t } = useTranslation();
  
  const getCTALabel = () => {
    switch (status) {
      case 1: return t('continueLesson');
      case 2: return t('reviewLesson');
      default: return t('startLesson');
    }
  };

  return (
    <div 
      className={`v2-mission-card ${loading ? 'v2-mission-card--loading' : ''} ${onPress && !loading ? 'v2-mission-card--clickable' : ''}`} 
      onClick={!loading ? onPress : undefined} 
    >
      <h3 className="v2-mission-card__title" title={title}>{title}</h3>
      
      <div className="v2-mission-card__content">
        <div className="v2-mission-card__info">
          <span className="v2-mission-card__progress-text">
            {completed} {t('outOf')} {total} {type === 'exercise' ? t('sections') : t('steps')}
          </span>
        </div>
        
        <div className="v2-mission-card__visual">
          <div className="v2-mission-card__status-row">
              <span className="v2-mission-card__cta">{getCTALabel()}</span>
              <div className="v2-mission-card__percentage">
                {percentage}%
              </div>
          </div>
          <div className="v2-mission-card__progress-bar-bg">
            <div 
              className="v2-mission-card__progress-bar-fill" 
              style={{ 
                '--progress-width': `${percentage}%`, 
                '--progress-color': textColor || '#15A5B5' 
              } as React.CSSProperties} 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionCard;
